<template>
  <login-wrapper>
    <detail-wrapper type="house">
    </detail-wrapper>
  </login-wrapper>
</template>

<script>
import { DetailWrapper } from '@/components'
import { LoginWrapper } from '@/components/common'

const name = 'house'

const components = {
  DetailWrapper,
  LoginWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: '2018 House Forecast'
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/House.vue